// extracted by mini-css-extract-plugin
module.exports =  {"phoneBlock":"phoneBlock___DlKnB","phoneMask":"phoneMask___rNlWM"};